import axiosMethods from "../mixins/axios";

export default {
  async searchUsers(url) {
    return await axiosMethods.get(url);
  },
};
